import gql from 'graphql-tag';
import { DocumentNode } from 'graphql';
import AnalyticsTypes from '../constants/AnalyticsTypes';

interface BuildVars {
  (analyticsType: AnalyticsTypes): { input: {
    resourceId: string,
    sessionId: string,
    visitorId: string,
    analyticsType: AnalyticsTypes
  } };
}

interface CreateAnalyticsEntryQuery {
  mutation: DocumentNode;
  module: string;
  buildVariables: BuildVars
}

const createAnalyticEntryQuery = gql`
  mutation CreateAnalyticsEntry($input: createAnalyticsEntryInput!) {
    createAnalyticsEntry(input: $input)
  }
`;

const createAnalyticEntry = (
  resourceId: string,
  visitorId: string,
  sessionId: string
): CreateAnalyticsEntryQuery => ({
  mutation: createAnalyticEntryQuery,
  module: 'analytics',
  buildVariables: (analyticsType: AnalyticsTypes) => ({
    input: {
      resourceId,
      visitorId,
      sessionId,
      analyticsType
    }
  })
});

export default createAnalyticEntry;
